import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import AutocompleteBase, { AutocompleteBaseProps } from "@/components/ui/Form/Filters/components/Autocomplete/AutocompleteBase";

export interface AutocompleteControlledProps extends AutocompleteBaseProps {
  control: Control;
}
const AutocompleteControlled: FC<AutocompleteControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <AutocompleteBase field={field} fieldState={fieldState} {...rest} />;
};
export default AutocompleteControlled;
